const detectBrowser = (): string | null => {
    const agent = navigator.userAgent;
    let browser = null;

    if (/Opera\/|OPR\//.test(agent)) {
        // @ts-ignore
        browser = 'Opera';
    } else if (/Edg\//.test(agent)) {
        // @ts-ignore
        browser = 'Edge';
    } else if (/Chrome\//.test(agent)) {
        // @ts-ignore
        browser = 'Chrome';
    } else if (/Safari\//.test(agent)) {
        // @ts-ignore
        browser = 'Safari';
    } else if (/Firefox\//.test(agent)) {
        // @ts-ignore
        browser = 'Firefox';
    } else if (/MSIE\//.test(agent)) {
        // @ts-ignore
        browser = 'Internet Explorer';
    }

    return browser;
};

export default detectBrowser;
